module.exports = __webpack_public_path__ + "static/img/buddy_pictgrid29_920x829.92ba743.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/buddy_pictgrid29_920x829.jpg
// module id = CFGH
// module chunks = 0